<template>
  <div class="vc-Bagde" :style="{ backgroundColor: color }">
    {{ text }}
  </div>
</template>

<script setup lang="ts">
type Props = {
  text?: string;
  color?: string;
}
withDefaults(defineProps<Props>(), {
  text: "NOVO!",
  color: "#0055FF"
});
</script>

<style lang="scss" scoped>
@use "@/ui/styles/theme/f360-theme" as *;
@use "@/ui/styles/variables" as *;

.vc-Bagde {
  font-family: "Plus Jakarta Sans", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 12px;
  padding: 2px 2px;
  gap: 10px;
  border-radius: 2px;
  color: #fff;
  font-size: 7px;
}
</style>
